import { uiAlert } from "../components/alerts/customAlert/uiAlert";

export const uploadloadOneImage = async (event, setImageResults, endpoint, imageName, passedEvent = true, readImageBuffer) => {
  if (passedEvent) {
    let imageBuffer;

    const image = event.target.files[0];
    imageBuffer = image;

    if (image) {
      const reader = new FileReader();
      reader.onload = function (evt) {
        setImageResults(evt.target.result);
      };
      reader.readAsDataURL(image);
    } else {
      uiAlert("Image uploaded failed", "error");
    }

    try {
      let imageToUpload = new FormData();
      imageToUpload.append(imageName, imageBuffer);

      let response = await fetch(endpoint, {
        method: "POST",
        headers: {
          authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        body: imageToUpload,
      });
      if (response.ok) {
        return await response.json();
      } else {
        uiAlert("error uploading image", "error");
      }
    } catch (error) {
      console.log(error);
    }
  } else {
    try {
      let imageToUpload = new FormData();
      imageToUpload.append(imageName, readImageBuffer);

      let response = await fetch(endpoint, {
        method: "POST",
        headers: {
          authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        body: imageToUpload,
      });
      if (response.ok) {
        return await response.json();
      } else {
        uiAlert("error uploading image", "error");
      }
    } catch (error) {
      console.log(error);
    }
  }
};
